// src/store/reducers/festival.reducer.ts
import { createReducer, on } from '@ngrx/store';
import { FestivalActions } from '../actions/festival.actions';
import { initialFestivalState } from '../states/festival.state';

export const festivalReducer = createReducer(
  initialFestivalState,

  on(FestivalActions.loadFestivalTheme, (state, { countryCode }) => ({
    ...state,
    loading:     true,
    error:       null,
    countryCode,
  })),

  on(FestivalActions.loadFestivalThemeSuccess, (state, { festivals, activeFestival }) => ({
    ...state,
    loading:        false,
    festivals,
    activeFestival,
    bannerVisible:  !!activeFestival,
  })),

  on(FestivalActions.loadFestivalThemeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(FestivalActions.dismissFestivalBanner, (state) => ({
    ...state,
    bannerVisible: false,
  })),

  on(FestivalActions.setActiveFestival, (state, { festival }) => ({
    ...state,
    activeFestival: festival,
    bannerVisible:  !!festival,
  })),

  on(FestivalActions.clearFestivalTheme, (state) => ({
    ...initialFestivalState,
    countryCode: state.countryCode, // preserve country
  }))
);